export const reduceAddonPrices = (rentalItem) => {
    if (!rentalItem.add_ons) {
        return 0;
    }
    return rentalItem.add_ons.reduce((total, addon) => total + addon.price, 0);
};
// Example url: /checkout/326/106-w-oliver-st
/**
 * Extracts the parking spot ID from a given Checkout URL.
 * @param url - The Checkout URL to extract the parking spot ID from.
 */
export const getParkingSpotIdFromUrl = (url) => {
    if (!url) {
        return null;
    }
    const match = url.match(/\/checkout\/(\d+)\//);
    return match ? parseInt(match[1], 10) : null;
};
